/**
 * This Component is intentionally light. It exists separately
 * to ease server side rendering.
 */
import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Route} from 'react-router-dom';
import {ThemeProvider} from 'styled-components';

import {getTheme} from '@ey/styled-theme';

import Utility from '../util/utilityfunctions';
import {userTheme} from '../util/uiconstants';
import {setLanguage} from '../util/utils';

import App from './App';
import Nav from './Common/Nav/Nav';
// import Errors from './Common/Errors/Errors';
import Notifications from './Common/Notifications';

const Routes = () => {
	const [isDarkMode, setIsDarkMode] = useState(false);

	const preferredTheme = useSelector((store) => store.userPreferences.theme);
	const languageISOCode = useSelector((store) => store.userPreferences.languageISOCode);

	useEffect(() => {
		setIsDarkMode(preferredTheme === userTheme.dark);
		Utility.setMotifTheme(preferredTheme === userTheme.dark ? userTheme.dark : userTheme.light);
	}, [preferredTheme]);

	useEffect(() => {
		if (languageISOCode) setLanguage(languageISOCode);
	}, [languageISOCode]);

	return (
		// key added because there was issue in refreshing Error Component
		<ThemeProvider theme={getTheme(isDarkMode)} key={languageISOCode}>
			<Nav />
			{/* <Errors key={languageISOCode} /> */}
			<Notifications />
			<Route path="/" component={App} />
		</ThemeProvider>
	);
};

export default Routes;
